import axios from "axios";
import { Base_URL } from "../url";

export const saveBudgetMasterDetails = async (budgetData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/BudgetMaster?UserName=${userName}`,
      budgetData,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to save Budget Master";
  }
};